import axios from "axios"
import { toast } from "react-toastify"
import useAuth from "./useAuth"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"

export const dvSrv = process.env.REACT_APP_DV_API_URL 
  || `http://localhost:${process.env.REACT_APP_DV_API_PORT}`

const api = axios.create({
  baseURL: dvSrv,
  // headers: { "Content-Type": 'application/json' },
  withCredentials: true
})

const useDeepVinApi = (needAuth = true) => {
  const { auth, setAuth } = useAuth()
  const navigate = useNavigate()
  
  useEffect(() => {
    if (!needAuth || (needAuth && Object.keys(auth).length === 0)) {
      //navigate('/signin')
      return
    }
    
    const interceptor = api.interceptors.response.use(
      response => response,
      async (error) => {
        if (error.response && error.response?.status === 401) {
          // toast.warn("Unauthorized error detected")
          setAuth({})
          // localStorage.removeItem('token')
          navigate('/signin')
        }
        return Promise.reject(error)
      }
    )
    //cleanup the interceptor on unmount
    return () => api.interceptors.response.eject(interceptor)
  }, [navigate])

  return api
}

export default useDeepVinApi

// axiosAgent.interceptors.response.use(
//   (resp) => {
//     return resp
//   },
//   async (err) => {
//     const originConfig = err.config

//     if (err.response) {
//       if (err.response.status === 401 && !originConfig._retry) {
//         originConfig._retry = true

//         try {
//           // get the new token

//           return axiosAgent(originConfig)
//         } catch (_error) {

//           return Promise.reject(_error.response.data)
//         }
//       }
//       if (err.response.status === 403 && err.response.data) {
//         return Promise.reject(err.response.data)
//       }
//     }

//     return Promise.reject(err)
//   }
// )
